import api from '@/lib/api-client';
import type { ProjectLink, ProjectLinkPayload } from '@/types/api';

export const projectLinkService = {
  list: async (projectId: string): Promise<ProjectLink[]> => {
    const { data } = await api.get<ProjectLink[]>(`/projects/${projectId}/links`);
    return data;
  },

  create: async (projectId: string, payload: ProjectLinkPayload): Promise<ProjectLink> => {
    const { data } = await api.post<ProjectLink>(`/projects/${projectId}/links`, payload);
    return data;
  },

  update: async (projectId: string, linkId: string, payload: ProjectLinkPayload): Promise<ProjectLink> => {
    const { data } = await api.put<ProjectLink>(`/projects/${projectId}/links/${linkId}`, payload);
    return data;
  },

  delete: async (projectId: string, linkId: string): Promise<void> => {
    await api.delete(`/projects/${projectId}/links/${linkId}`);
  },

  reorder: async (projectId: string, orderedIds: string[]): Promise<void> => {
    await api.patch(`/projects/${projectId}/links/reorder`, { orderedIds });
  },
};
